import { render, staticRenderFns } from "./ApprovedTable.vue?vue&type=template&id=b3ab858a&"
import script from "./ApprovedTable.vue?vue&type=script&lang=js&"
export * from "./ApprovedTable.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedTable.vue?vue&type=style&index=0&id=b3ab858a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports